"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _Avatar = require("./Avatar.styles");

var _icons = require("../../assets/icons");

var NotAvatar = (0, _base["default"])("div", {
  target: "eoqgd570",
  label: "NotAvatar"
})(_Avatar.styles.notAvatar, ";");

var Avatar = function Avatar(_ref) {
  var avatar = _ref.avatar,
      userName = _ref.userName,
      className = _ref.className,
      size = _ref.size;

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      hasError = _useState2[0],
      setHasError = _useState2[1];

  var handleError = (0, _react.useCallback)(function (e) {
    setHasError(e.type === 'error');
  }, []);
  (0, _react.useEffect)(function () {
    if (!avatar) {
      setHasError(true);
      return undefined;
    }

    var image = new Image();
    image.src = avatar;
    image.addEventListener('error', handleError);
    image.addEventListener('load', handleError);
    return function () {
      // Remove events when the component is unmounted
      image.removeEventListener('error', handleError);
      image.removeEventListener('load', handleError);
    };
  }, [avatar, handleError]);

  if (hasError && userName) {
    return (0, _jsxRuntime.jsx)(NotAvatar, {
      className: className,
      size: size,
      children: userName[0]
    });
  }

  return (0, _jsxRuntime.jsx)("div", {
    className: className,
    css: _Avatar.styles[size],
    style: hasError === false ? {
      backgroundImage: "url(".concat(avatar, ")")
    } : {},
    children: hasError && (0, _jsxRuntime.jsx)(_icons.User, {})
  });
};

Avatar.propTypes = {
  avatar: _propTypes.string,
  userName: _propTypes.string,
  className: _propTypes.string,
  size: (0, _propTypes.oneOf)(['big', 'small', 'xl'])
};
Avatar.defaultProps = {
  avatar: undefined,
  userName: undefined,
  className: undefined,
  size: 'big'
};
var _default = Avatar;
exports["default"] = _default;
//# sourceMappingURL=Avatar.js.map